import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
        // PrimeReact core
import "primereact/resources/primereact.min.css";

// PrimeReact theme (choose ONE)
import "primereact/resources/themes/lara-light-indigo/theme.css";
// or lara-light-blue, lara-dark-indigo, etc.

// PrimeIcons
import "primeicons/primeicons.css";

import "./index.css";



import App from "./App";
// import App from "./DynamicApp";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
   <PrimeReactProvider
  value={{
    ripple: true,
    zIndex: {
      modal: 1200,
      overlay: 1100,
      menu: 1100,
      tooltip: 1200,
      toast: 1300,
    },
  }}
>
      <App />
    </PrimeReactProvider>
  </BrowserRouter>
);
